export default __webpack_public_path__ + "static/media/background.8606724d.png";